<template>
    <!-- Mobile: the tab nav is easy to miss, so Update looks like it did nothing. -->
    <p class="review-mobile-note d-md-none">
        Clicking <strong>{{ action }}</strong> saves this section and opens the next tab.
        Continue through each tab to <strong>Review &amp; Sign</strong> to complete your review.
    </p>
</template>
<script>
export default {
    name: 'ReviewNextNote',
    props: {
        action: { type: String, default: 'Update' },
    },
};
</script>
